import React, { useContext } from 'react';
import styled from 'styled-components';
import { ContactContext } from './ContactContext';
import mediaQueries from '../../styles/mediaQueries';

interface ContactButtonProps {
  className?: string;
  variant?: 'primary' | 'secondary' | 'outline';
  children?: React.ReactNode;
  context?: string; // Contexte d'où provient le bouton (ex: "Page d'accueil", "Footer", etc.)
}

const StyledButton = styled.button<{ variant: string; className?: string }>`
  background-color: ${({theme}) => theme.colors.secondary};
  color: white;
  padding: 12px 24px;
  border-radius: 32px;
  font-size: 16px;
  font-weight: var(--font-weight-medium);
  transition: background-color 0.3s;
  cursor: pointer;
  border: none;
  outline: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  
  &:hover {
    background-color: #c42b12;
  }
  
  ${props => props.variant === 'primary' && `
    background-color: ${props.theme.colors.secondary};
    color: ${props.theme.colors.white};
  `}
  
  ${props => props.variant === 'secondary' && `
    background-color: ${props.theme.colors.primary};
    color: ${props.theme.colors.white};
    
    &:hover {
      background-color: ${props.theme.colors.lightPrimary};
    }
  `}
  
  ${props => props.variant === 'outline' && `
    background-color: transparent;
    color: ${props.theme.colors.secondary};
    border: 2px solid ${props.theme.colors.secondary};
    
    &:hover {
      background-color: rgba(221, 49, 20, 0.05);
    }
  `}
  
  ${mediaQueries.small} {
    padding: 10px 20px;
    font-size: 14px;
  }
`;

const ContactButton: React.FC<ContactButtonProps> = ({ 
  className, 
  variant = 'primary',
  children = 'Nous contacter',
  context = ''
}) => {
  const { openModal, openModalWithContext } = useContext(ContactContext);
  
  const handleClick = () => {
    if (context) {
      console.log(`Contact depuis: ${context}`); // Aide au débogage
      openModalWithContext(context);
    } else {
      openModal();
    }
  };
  
  return (
    <StyledButton 
      className={className} 
      variant={variant}
      onClick={handleClick}
    >
      {children}
    </StyledButton>
  );
};

export default ContactButton;